export class TwoWalletEventError extends Error {
  readonly status: number | undefined;
  readonly details: unknown;

  constructor(message: string, status?: number, details?: unknown) {
    super(message);
    this.name = 'TwoWalletEventError';
    this.status = status;
    this.details = details;
  }
}
